import { Notifications } from 'react-native-notifications';

import { isIOSPlatform } from '../../../Common/services/utils/AppConstants';

export const updateBadgeCount = (unreadNotifications: number): void => {
  isIOSPlatform && Notifications.ios.setBadgeCount(unreadNotifications);
};
